export default __webpack_public_path__ + "static/media/Tooltip.fc7d81fa.svg";